import React, { useEffect, useState } from "react";
import style from "./DataObjects.module.css";
import Tree from "./DataObjectTreeNode";
import Menu from "@material-ui/core/Menu";
import DataObjectPlus from "../../../Icons/DataObjectPlus";
import DataObjectsAddBttn from "../../../Icons/DataObjectsAddButtn"
import axios from "../../../axios";
import axios1 from "axios";
import {
  fetchProcessModularData,
  fetchProcessTaskTemplate,
  fetchProcessGlobalTemplate,
} from "./../../IFormDesignerLayout/RequestLogic";
import DataObjectsBackdrop from "./DataObjectsBackdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { MenuItem, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { GetStateFromData } from "../../CustomHooks/CustomHooks";
import { getContainerId, getFormId, setCurrentDataObjectsContent } from "../../IFormDesignerLayout/IFormDesignerLogic";
import { formStateStore } from "../../../Redux/Store/store";
import secureLocalStorage from "react-secure-storage";
import secureSessionStorage from "../../../utils/secureSessionStorage";

const DataObjects = (props) => {
  const { t } = useTranslation();
  const [showMapButton, setShowMapButton] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [deLinkState, setDeLinkState] = useState(false);
  const open = Boolean(anchorEl);
  const contexts = GetStateFromData();

  const {
    dataObjectsContent,
    setDataObjectsContent,
    microFrontendData,
    activePage,
    appId,
    filteredDataObject,
    setfilteredDataObject,
    activeApplication,
    setfilteredDataObjectCopy,
    updateDataObject,
    showAlertConfirmNotifications,
  } = contexts.contexts;

  const [portalState, setPortalState] = React.useState(
    microFrontendData?.formPageType || microFrontendData?.processName
      ? "Processes"
      : "Portals"
  );
  const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
  var jwtToken = launchpadKey || undefined;

  const [dataObjectType, setDataObjectType] = React.useState("");
  const [selectedParamType, setSelectedParamType] = React.useState("");
  const [dataLoaded, setDataLoaded] = React.useState(false);

  const [dataObjectsBackdropState, setDataObjectsBackdropState] =
    React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedControl, setSelectedControl] = useState("");
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";

    // function fetchingChildren(event, dataC) {
    //   window.loading(true)  
    //   var treeName = "";
    //   if (dataC?.treeName) {
    //     treeName = dataC?.treeName;
    //   }  
    //   var currName = dataC.VariableName;
    //   var parentname = currName;
      
    //   axios1.post("/mdm-rest/app/gettabledefinition", {
    //     id: dataC ? (dataC.VariableId ? dataC.VariableId : "") : "",
    //     name: parentname || "",
    //     status: "1",
    //   }, {
    //     headers: {
    //       "Content-Type": "application/json",
    //     }
    //   })
    //     .then(function (content) {
    //       var data = JSON.stringify(content?.data?.data);
    //       let formId = getFormId();
    //       const jsonData = {
    //         formId: activePage?.formId || formId.toString(),
    //         data: `${data}`,
    //         treeName: treeName,
    //       };
  
    //       axios
    //         .post("/idesign/gettableDefinition", jsonData, {
    //           withCredentials: true,
    //         })
    //         .then((response) => {
  
    //           dataC.children = response.data.children;
  
    //           if (response.data.children) {
    //             for (let child of response.data.children) {
    //               if (child?.MappingInfo) {
    //                 fetchingChildren("", child);
    //               }
    //             }
    //           }
    //         })
    //         .catch(function (error) {
    //           if (error.response) {
    //           }
    //           console.log("error is", error);
    //         });
    //         window.loading(false)
    //     })
    //     .catch((err) => {
    //       console.log("error is", err);
    //       window.loading(false)
    //     });
    // }

    const fetchingAllDataObjects = async (dataC, isParent) => {
      window.loading(true)
      let count = 0;
      const parentname = dataC?.VariableName
  
      const jsonData = {
        parentTableId: dataC ? (dataC?.VariableId ? dataC?.VariableId : "") : "",
        treeName: parentname || "",
        status: "1",
        formId: getFormId().toString()
      }
  
      let finalDataObjects = await axios
      .post("/idesign/gettableDefinition", jsonData, {
        withCredentials: true,
      })
      .then((response) => {
        if (isParent === true) {
          return true;
        }
        return response?.data || {}
      })
      .catch((error) => {
        if(error.response){
        }
        console.log("error")
      })
      window.loading(false)
      return [finalDataObjects]
    }

  const getDataObjects = () => {
    fetch("/mdm-rest/app/dataobjects", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwtToken,
      },
      body: JSON.stringify({
        parent_id: appId,
        type: "AP",
        sort_order: "A",
        order_by: "1",
        records_to_fetch: "30",
        mode: "tree",
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (content) {
        if (content.status.subject === "No Data Objects found.") {
          setDataObjectsContent([]);
          setfilteredDataObject([]);
          setfilteredDataObjectCopy([]);
          setIsLoading(false);
        } else {
          if (content.data.data_objects !== undefined) {
            var data = JSON.stringify(content.data.data_objects);
            let formId = getFormId()
            const jsonData = {
              formId: activePage?.formId || formId.toString(),
              data: `${data}`,
            };
            axios
              .post("/idesign/getDataObjectsforMapping", jsonData, {
                withCredentials: true,
              })
              .then(async (response) => {
                if (response.data["children"]) {
                  if(response.data["children"]?.length > 1){
                      showAlertConfirmNotifications({
                        'open':true,
                        'showConfirm':'showNotification',
                        'alertType':'error',
                        'alertContentKey': "Only one parent table is allowed. Please define the parent-child relation with the system-generated parent table."
                      });
                    } else {
                      for (let child of response.data["children"]) {
                        // fetchingChildren("", child);
                        response.data["children"] = await fetchingAllDataObjects(child)

                        setDataObjectsContent(response.data["children"]);
                        setfilteredDataObject(response.data["children"]);
                        setfilteredDataObjectCopy(response.data["children"]);
                        setCurrentDataObjectsContent(response.data["children"]);
                        setIsLoading(false);
                      }
                    }
                }
                // setDataObjectsContent(response.data["children"]);
                // setfilteredDataObject(response.data["children"]);
                // setfilteredDataObjectCopy(response.data["children"]);
                // setIsLoading(false);
                setDataLoaded((prev) => !prev);
              })
              .catch(function (error) {
                console.log("Error");
              });
          }
        }
      })
      .catch((err) => {
        console.log("error");
      });
  };
  useEffect(() => {
    if (Object.keys(dataObjectsContent).length === 0 || deLinkState) {
      setDeLinkState(false);
      if (microFrontendData?.componentType === "TF") {
        setIsLoading(true);
        var jsonForProcess = {
          taskId: microFrontendData?.taskId,
          processdefId: microFrontendData?.processDefId,
          processState: microFrontendData?.statusType || "L",
        };

        fetchProcessTaskTemplate(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
            setIsLoading(false);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      } else if (microFrontendData?.componentType === "GT") {
        setIsLoading(true);
        var jsonForProcess = {
          globalTemplateId: microFrontendData?.templateId,
        };

        fetchProcessGlobalTemplate(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
            setIsLoading(false);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      } else if (portalState === "Portals") {
        setIsLoading(true);
        getDataObjects();
      } else if (portalState === "Processes") {
        setIsLoading(true);
        var jsonForProcess = {
          processdefId: microFrontendData?.processId,
          processState: microFrontendData?.statusType,
          formId: microFrontendData?.formDefId,

          processName: microFrontendData?.processName,
        };

        fetchProcessModularData(jsonForProcess)
          .then((response) => {
            var processData = response.data;
            setDataObjectsContent(processData["children"]);
            setfilteredDataObject(processData["children"]);
            setfilteredDataObjectCopy(processData["children"]);
            props.setSearch("");
            setIsLoading(false);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      }
    }
  }, [portalState]);

  function handleDataObjectsPopupClose() {
    setDataObjectsBackdropState(false);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const callbackMethod = (data) => {
    console.log(data);
    if (data) {
      getDataObjects();
    }
  };

  const state=formStateStore.getState();
  let containerId = getContainerId()
 if(containerId===undefined){
   containerId="default"
 }
 
  let nonceValue= state.data.find(json => json.key === containerId)?.noncevalue;

  let microProps = {
    Noncevalue: nonceValue,
    source: "PD_CMP", //PD_EXT
    data_object_alias_name: "", // Mandatory in props in PD_EXT
    data_object_name: "", // Mandatory in props in PD_EXT
    data_object_id: "",
    object_type: "AP", //AP/P/C
    object_id: appId,
    auto_generate_table: true,
    default_data_fields: [
      {
        name: "referencekey",
        alias: "referencekey",
        // name: "map_id",
        // alias: "Map Id",
        type: 1,
        key_field: true,
        id: 1,
      },
    ],
    ContainerId: "dataObjectContainerIform_builder",
    Module: "MDM",

    Component: "DataModelDesignerViewer",

    InFrame: false,
    Callback: callbackMethod,
    data_types: [1, 2, 3, 4, 5, 8, 9, 10, 11, 12],
  };
  function openMdmObjectsModel(param) {
    setSelectedParamType(param);

    let temp = { ...microProps };
    if (param === "Y" || param === "N") {
      temp.use_existing = param;
    } else if (param === "data_source" || param === "system") {
      temp.upload = param;
      temp.use_existing = "N";
    }
    temp.object_name = activeApplication?.applicationName || "";
    temp.parentDataObject = filteredDataObject[0]?.SystemDefinedName;
    temp.parentDataObjectId = filteredDataObject[0]?.VariableId;
    window.MdmDataObjectsModel(temp);
    handleClose();
  }
  const complexOptions = [
    { paramType: "N", label: t("createDataObject") },
    { paramType: "Y", label: t("copyAvailableDataObject") },
    { paramType: "system", label: t("uploadFromMyComputer") },
    { paramType: "data_source", label: t("importFromDataSource") },
  ];

  const modifyDataObjectCallback = (data) => {
    console.log(data);
    getDataObjects();
  };

  const openModifyMF = (dataObject) => {
    let microMFProps = {
      uniqueNumber: nonceValue,
      source: "PD_CMP", //PD_EXT
      template_id: "",
      data_object_alias_name: dataObject?.VariableName.split(".").join(" "), // Mandatory in props in PD_EXT
      data_object_name: dataObject?.VariableName, // Mandatory in props in PD_EXT
      data_object_id: +dataObject?.VariableId,
      object_id: appId,
      object_type: "AP", //AP/P/C
      auto_generate_table: true,
      ContainerId: "dataObjectModifyContainerIform_builder",
      Module: "MDM",
      Component: "DataModelListViewer",
      InFrame: false,
      Callback: modifyDataObjectCallback,
      data_types: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
    };
    window.MdmDataObjectsModel(microMFProps);
  };
  return (
    <div
      className={style.dataObjects}
      style={{ height: "auto", overflow: "auto" }}
    >
      <div
        className={style.dataObjectPortal}
        style={
          props.isWS === true
            ? { display: "none" }
            : translationStyles1
            ? { display: "flex", justifyContent: "space-between" }
            : null
        }
      >
        <span className={style.currentDataObject}> {t("Data Objects")}</span>{" "}
        &nbsp;
        {/* {portalState === "Portals" && (
          <span className={style.currentDataObject}>{t(portalState)}</span>
        )} */}
        {portalState === "Portals" && (
          <span
            className={style.downArrowClass}
            style={translationStyles1 ? { paddingLeft: "4px" } : null}
            onClick={handleClick}
          >
            {" "}
            &nbsp;
            <DataObjectsAddBttn />
          </span>
        )}
      </div>
      <Menu
        style={props.isWS === true ? { display: "none" } : null}
        id="dataObjects-long-menu"
        anchorEl={anchorEl}
        keepMounted
        className={style.menuDataObjectsModel}
        open={open}
        onClose={handleClose}
        MenuListProps={{ disablePadding: true }}
        PaperProps={{
          style: {
            width: "222px",
            marginTop: "20px",
            marginLeft: "0px",
            height: "auto",
          },
        }}
      >
        <MenuItem></MenuItem>
        <div tabIndex="none">
          {complexOptions.map((item, index) => (
            <div
              key={index}
              className={
                selectedParamType === item.paramType
                  ? style.portalProcessAfterClickClass
                  : style.portalProcessClass
              }
              onClick={() => openMdmObjectsModel(item.paramType)}
            >
              <Typography style={{ fontSize: "12px" }}>{item.label}</Typography>
            </div>
          ))}
        </div>
      </Menu>
      {filteredDataObject?.length > 0 ? (
        <Tree
          data={filteredDataObject}
          createNewElement={props.createNewElement}
          showMapButton={showMapButton}
          setShowMapButton={setShowMapButton}
          isWS={props.isWS}
          dataRef={props.dataRef}
          setDeLinkState={setDeLinkState}
          mappedServiceRef={props.mappedServiceRef}
          setSelectedControl={setSelectedControl}
          selectedControl={selectedControl}
          setSelectedContent={props.setSelectedContent}
          openModifyDataObjMf={openModifyMF}
          portalState={portalState}
        />
      ) : isLoading === true ? (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          {t("No Data Object Found.")}
        </div>
      )}
      {dataObjectsBackdropState ? (
        <DataObjectsBackdrop
          containerId={props.containerId}
          handleDataObjectsPopupClose={handleDataObjectsPopupClose}
          dataObjectType={dataObjectType}
        />
      ) : (
        ""
      )}
      <div
        style={{
          display: "none",
        }}
        id="dataObjectContainerIform_builder"
      ></div>
      <div
        style={{
          display: "none",
        }}
        id="dataObjectModifyContainerIform_builder"
      ></div>
    </div>
  );
};

export default React.memo(DataObjects);
